// import jsPDF from "jspdf";

// export const exportPdf = (fileName, ref) => {

//   const doc = new jsPDF(
//     {
//       format: "a4",
//       unit: "px",
//       precision: 100
//     }
//   );

//   doc.html(ref.current, {
//     margin: [16, 12],

//     async callback(doc) {
//       doc.save(`${fileName}.pdf`);
//     }
//   });

// };

import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export const exportPdf = async (fileName, ref) => {
  const scale = 2; // High resolution for better quality
  const marginX = 16; // Left & right margins in px
  const marginY = 12; // Top & bottom margins in px

  const canvas = await html2canvas(ref.current, {
    scale: scale,
    scrollX: 0,
    scrollY: 0,
    useCORS: true,
  });

  const imgData = canvas.toDataURL("image/png");

  const pageWidth = 210; // A4 width in mm
  const pageHeight = 297; // A4 height in mm

  // Convert margin from px to mm
  const marginXmm = marginX / 2.83;
  const marginYmm = marginY / 2.83;

  // Calculate image dimensions while maintaining aspect ratio
  const imgWidth = pageWidth - 2 * marginXmm;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;

  const doc = new jsPDF({
    orientation: imgHeight > pageHeight - 2 * marginYmm ? "portrait" : "landscape",
    unit: "mm",
    format: "a4",
  });

  // Make sure image fits within the page
  if (imgHeight > pageHeight - 2 * marginYmm) {
    const newImgHeight = pageHeight - 2 * marginYmm;
    const newImgWidth = (canvas.width * newImgHeight) / canvas.height;
    doc.addImage(imgData, "PNG", marginXmm, marginYmm, newImgWidth, newImgHeight);
  } else {
    doc.addImage(imgData, "PNG", marginXmm, marginYmm, imgWidth, imgHeight);
  }

  doc.save(`${fileName}.pdf`);
};
